import _cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import { getQueryParams } from 'src/utils/browser';
import {
  buildCustomDateRangeDisplayName,
  getWeekFirstDate,
  getWeekLastDate,
  capDateToCurrentDate,
  computeMainTimePeriod,
  getDayIdFromDate
} from 'src/utils/dateformatting';
import { getWeekId } from 'src/utils/dateUtils';

export const createTimePeriodDateObject = (
  timePeriodObject,
  startWeek,
  endWeek,
  startDayId?: string,
  endDayId?: string
) => {
  const isAd = getQueryParams('tab') === 'advertising';

  timePeriodObject.startWeek = startWeek;
  timePeriodObject.endWeek = endWeek;

  timePeriodObject.startWeekStartDate = getWeekFirstDate(startWeek);
  timePeriodObject.endWeekEndDate = capDateToCurrentDate(getWeekLastDate(endWeek));
  timePeriodObject.startDayId = !isAd ? getDayIdFromDate(timePeriodObject.startWeekStartDate) : startDayId;
  timePeriodObject.endDayId = !isAd ? getDayIdFromDate(timePeriodObject.endWeekEndDate) : endDayId;
  timePeriodObject.displayName = buildCustomDateRangeDisplayName(
    timePeriodObject.startDayId,
    timePeriodObject.endDayId
  );
  timePeriodObject.timePeriodSuffix = {
    dayId: `_${timePeriodObject.startDayId}_${timePeriodObject.endDayId}`,
    weekId: `_${timePeriodObject.startWeek}_${timePeriodObject.endWeek}`
  };

  if (timePeriodObject.id === 'mtd') {
    const endWeekEndDate = moment().subtract(1, 'day').toDate();
    timePeriodObject.startWeekStartDate = moment(endWeekEndDate).startOf('month').toDate();
    timePeriodObject.endWeekEndDate = moment(endWeekEndDate).toDate();
    timePeriodObject.startWeek = getWeekId(timePeriodObject.startWeekStartDate);
    timePeriodObject.endWeek = getWeekId(timePeriodObject.endWeekEndDate);
    timePeriodObject.startDayId = getDayIdFromDate(timePeriodObject.startWeekStartDate);
    timePeriodObject.endDayId = getDayIdFromDate(timePeriodObject.endWeekEndDate);
  }

  return timePeriodObject;
};

export default function calculateAdditionalTimePeriods(
  allWeekIds,
  availableMainTimePeriods,
  updatedMainTimePeriod,
  app
) {
  const clonedTimePeriods = _cloneDeep(availableMainTimePeriods);
  const newAvailableTimePeriods = clonedTimePeriods.map((item) => {
    const newItem = item;

    if (item.id === 'cd') {
      if (updatedMainTimePeriod.id === 'cd') {
        const returnedItem = createTimePeriodDateObject(
          newItem,
          updatedMainTimePeriod.startWeek,
          updatedMainTimePeriod.endWeek
        );
        return returnedItem;
      } else if (item.startWeek) {
        return {
          id: newItem.id,
          shortDisplayName: newItem.shortDisplayName
        };
      } else if (updatedMainTimePeriod.id !== 'cd') {
        return newItem;
      }
    }

    const { startWeek, endWeek, startDayId, endDayId } = computeMainTimePeriod(allWeekIds, item, app);
    const returnedItem = createTimePeriodDateObject(newItem, startWeek, endWeek, startDayId, endDayId);
    return returnedItem;
  });
  return newAvailableTimePeriods;
}
